import { useContext } from 'react';
import AppContext from '../../../common/containers/AppContext';

export default function useGetFamilyById(familyId) {
    const appContext = useContext(AppContext);
    const families = appContext.families || [];
    const family = families.find(({ id }) => id === familyId);

    if (!family) {
        return [null, false, true];
    }

    return [family, false, false];
}
